/**
 * @file RestoreSlugForm.tsx
 * @description Новый адрес при восстановлении страницы (phase19.16 Р3а;
 * SB128): прежний адрес занят другой страницей — поле с подсказанным
 * `about-2`; ошибка сервера — под полем.
 */

import { useState } from "react";

import { Button } from "../../ui/button";
import { TextField } from "../../site-view/TextField";
import type { RestoreOutcome } from "../../../hooks/site-builder/useDeletedPages";
import { cleanSlugInput, PAGE_SLUG_MAX } from "../../../lib/site-builder/page-form";

interface Props {
  takenSlug: string;
  busy: boolean;
  onCancel: () => void;
  onSubmit: (slug: string) => Promise<RestoreOutcome>;
}

export function RestoreSlugForm({ takenSlug, busy, onCancel, onSubmit }: Props) {
  const [slug, setSlug] = useState(() => (takenSlug ? `${takenSlug}-2`.slice(0, PAGE_SLUG_MAX) : ""));
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    if (!slug.trim()) {
      setError("Укажите новый адрес.");
      return;
    }
    const res = await onSubmit(slug);
    if (res.kind === "slug") setError(`Адрес /${res.takenSlug || slug} тоже занят — укажите другой.`);
    else if (res.kind === "error") setError(res.text);
  }

  return (
    <div className="flex flex-col gap-2">
      <TextField
        label="Новый адрес страницы"
        value={slug}
        max={PAGE_SLUG_MAX}
        error={error}
        hint={takenSlug ? `Прежний адрес /${takenSlug} уже у другой страницы. Латиница, цифры и дефис.` : "Латиница, цифры и дефис."}
        onChange={(v) => {
          setError(null);
          setSlug(cleanSlugInput(v));
        }}
      />
      <div className="flex flex-wrap gap-2">
        <Button loading={busy} onClick={() => void submit()}>
          Восстановить с этим адресом
        </Button>
        <Button variant="ghost" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </div>
  );
}
